import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ITriggeringEvents, triggeringEventsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const TRIGGERING_EVENTS_MODULE = 'triggeringEvents';

const dataObjectModule = getDataObjectsModule<ITriggeringEvents>(triggeringEventsManager, 1);
const searchModule = getSearchModule<ITriggeringEvents>(triggeringEventsManager);

const triggeringEventsModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(TRIGGERING_EVENTS_MODULE, triggeringEventsModuleInstance);

export { TRIGGERING_EVENTS_MODULE };
